import { render, staticRenderFns } from "./SoftwareProjects.vue?vue&type=template&id=e376336a"
import script from "./SoftwareProjects.vue?vue&type=script&lang=js"
export * from "./SoftwareProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports